import type { ApolloError } from '@apollo/client';

// Match on the code, never the message: the message is localized and would only match in
// English. Raised by the mutations that include Mutations::Mixins::RemoteSession.
const CHANNEL_UNAVAILABLE = 'CHANNEL_UNAVAILABLE';
const SESSION_EXPIRED = 'SESSION_EXPIRED';

/**
 * The page is offering a channel the device's guide has since dropped, so the list it is showing
 * is stale. As with the codes below, a network error alongside means the request broke on the way.
 */
export const isChannelUnavailable = (error: ApolloError) =>
  error.networkError == null && error.graphQLErrors[0]?.extensions?.code === CHANNEL_UNAVAILABLE;

/**
 * The token died after the page loaded. A code arriving alongside a network error means the
 * request broke on the way, not that the session ended.
 */
export const isSessionExpired = (error: ApolloError) =>
  error.networkError == null && error.graphQLErrors[0]?.extensions?.code === SESSION_EXPIRED;

/** No answer at all — a phone off the wifi. An HTTP failure carries a `statusCode`. */
export const isUnreachable = (error: ApolloError | undefined) =>
  error?.networkError != null && !('statusCode' in error.networkError);
